module.exports = __webpack_public_path__ + "img/12.d98fbc51.png";